export default __webpack_public_path__ + "static/media/heart_bluepurple.03555edb.svg";